<template>
    <v-breadcrumbs :items="breadcrumbs">
        <template #item="{ item }">
            <v-breadcrumbs-item :to="item.to" exact :disabled="item.disabled" class="text-primary">
                {{ item.title }}
            </v-breadcrumbs-item>
        </template>
    </v-breadcrumbs>
    <card-skeleton>
        <card-title :text="t('register.registerSuccessTitle')"> </card-title>
        <v-card-text class="text-h6">
            <p>{{ t('register.registerSuccessFirstLine') }}</p>
            <br />
            <p>{{ t('register.registerSuccessText') }}</p>
        </v-card-text>
    </card-skeleton>
</template>

<script setup lang="ts">
import { routeNames } from '@/router';
import CardSkeleton from '@/features/common/components/CardSkeleton.vue';
import CardTitle from '@/features/common/components/CardTitle.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const breadcrumbs = [
    { title: t('startPage.home'), to: { name: routeNames.home } },
    { title: t('register.registerSuccessTitle'), to: '', disabled: true }
];
</script>
